module.exports = __webpack_public_path__ + "img/loading.ffb20abd.gif";